import styled from "@emotion/styled";
import { Helmet } from "react-helmet-async";

import euLogo from "../assets/images/european-union-logo-horizontal.jpg";
import pkipLogo from "../assets/images/pkip-logo-horizontal.png";

const TallEye = () => {
  return (
    <Wrapper>
      <Helmet>
        <title>TallEYE</title>
        <meta
          name="description"
          content="TallEYE - софтуерно решение, базирано на изкуствен интелект за анализ на сателитни изображения."
        />
      </Helmet>

      <Container>
        <Title>
          Стартира изпълнението на проект „TallEYE - софтуерно решение за анализ
          на сателитни изображения, базирано на изкуствен интелект“ по
          Оперативна програма „Конкурентоспособност и иновации в предприятията“
          2021-2027, финансиран от Европейски Съюз
        </Title>

        <LogosRow>
          <Logo src={euLogo} alt="European Union Logo" />
          <Logo src={pkipLogo} alt="PKIP Logo" />
        </LogosRow>

        <Description>
          <p>
            “Кодин Софт“ ЕООД започна изпълнението на проект „TallEYE -
            софтуерно решение за анализ на сателитни изображения, базирано на
            изкуствен интелект“ по Договор за безвъзмездна финансова помощ
            BG16RFPR001-1.001-0069/07.05.2025, финансиран от Европейски Съюз
            чрез Оперативна програма „Конкурентоспособност и иновации в
            предприятията“ 2021-2027.
          </p>

          <p>
            Същността на проекта е разработката на иновативно софтуерно решение/
            платформа, базирано на изкуствен интелект за анализ на сателитни
            изображения. Целта му е да трансформира начина, по който се извлича
            полезна информация, която да може да бъде използвана за различни
            нужди. Това решение ще предоставя мощни инструменти за автоматизиран
            анализ, които да помагат на потребителите да извличат ценна
            информация от геопространствени данни.
          </p>

          <p>
            Независимо дали става въпрос за земеделие, градско планиране,
            екология или сигурност, решението ще предлага адаптивност и
            гъвкавост, за да отговори на различни нужди. С използването на
            напреднали алгоритми за машинно обучение (machine learning) и
            компютърно зрение (computer vision), тази платформа ще анализира
            сателитни снимки в реално време или по заявка, за да предоставя
            детайлни анализи и употребими данни.
          </p>
        </Description>
      </Container>
    </Wrapper>
  );
};

export default TallEye;

const Wrapper = styled.div`
  background: #eef2f9;
  padding-top: 3rem;
  padding-bottom: 5rem;
`;

const Container = styled.div`
  width: 70%;
  margin: auto;

  @media (max-width: 1024px) {
    width: 89%;
  }
`;

const Title = styled.h1`
  font-family: "Outfit";
  text-align: center;
  font-size: 30px;
  line-height: 42px;
  margin-bottom: 3rem;
  margin-top: 3rem;
  color: #1c232c;

  @media (max-width: 1024px) {
    font-size: 24px;
    line-height: 36px;
  }
`;

const LogosRow = styled.div`
  display: flex;
  justify-content: center;
  gap: 15rem;
  margin-bottom: 4rem;

  @media (max-width: 1024px) {
    gap: 2rem;
  }
`;

const Logo = styled.img`
  height: 90px;
  width: auto;

  @media (max-width: 1024px) {
    height: 50px;
  }
`;

const Description = styled.div`
  font-family: "Outfit";
  color: #1c232c;
  font-size: 20px;
  line-height: 1.7;
  margin-bottom: 4rem;
  margin-top: 10rem;

  p {
    margin-bottom: 1.5rem;
  }

  @media (max-width: 1024px) {
    font-size: 18px;
  }
`;
